const actions = {
	StoreFront: "CriteoViewList",
	ProductDetail: "CriteoViewItem",
	Cart: "CriteoViewBasket"
};

export class CriteoActions {
	static get ACTIONS() {
		return actions;
	}
}
